module.exports = "<svg style=\"width: 16px; height: 16px\" viewBox=\"0 0 16 16\"><path d=\"M5,13.9914698 C5,13.9968131 11.000385,14 11.000385,14 C11.0020786,14 11,6 11,6 L5,6 L5,13.9914698 Z M13,5 L13,13.9914698 C13,15.1007504 12.1125667,16 11.000385,16 L4.99961498,16 C3.89525812,16 3,15.0980496 3,13.9914698 L3,5 L3,6 L13,6 L13,5 Z M5,0 L11,0 L11,2 L5,2 L5,0 Z M1,3 L15,3 L15,5 L1,5 L1,3 Z M7,6 L9,6 L9,12 L7,12 L7,6 Z\" id=\"path-1\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./assets/icons/trash.svg
// module id = 94
// module chunks = 0